import {styled} from '@volkswagen-onehub/components-core';
import React, {useContext, useEffect} from 'react';
import {CustomDetailsCTA} from '../../styles/components';
import {getLang, getTranslations} from '../../translations';
import { useFeatureServices } from '../../use-feature-services';
import { createConfiguration, createConstantData, createPartner, createProcess } from '../../utils/get-tracking-event-data';
import { FocusLayerSizeV2 } from '@volkswagen-onehub/layer-manager';
import BuildYourDealModal from './BuildYourDealModal';
import { LayerContext, useFocusLayer } from '../../Layers';
import { useDealersStore } from '../../utils/use-dealers-store';
import { VehicleData } from '../../types';

interface BuildYourDealInterface {
  vehicle: VehicleData;
};

const BuildYourDealCtaWrapper = styled.a`
  text-decoration: none;
`;

export default ({vehicle}: BuildYourDealInterface) => {
  const { tracking } = useFeatureServices();
  const { getDealer } = useDealersStore();
  const dealer = getDealer(vehicle?.dealer_id);
  const lang = getLang();
  const trans = getTranslations();

  const { closeLayer } = useContext(LayerContext);

  const openMotoinsightConfirmationLayer = useFocusLayer('motoinsight-layer', {
    size: FocusLayerSizeV2.C,
    onClose: () => closeLayer('motoinsight-layer'),
  });

  useEffect(() => {
    setTimeout(() => {
      window.MOTOINSIGHT.updateView(`${lang}-ca`);
    }, 500);
  }, []);

  const onBuildCta = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    openMotoinsightConfirmationLayer((close) => <BuildYourDealModal close={close} vehicle={vehicle} />);
    tracking.track('VWBasic_VehicleButton_Click', {
      ...createConstantData('VWBasic_VehicleButton_Click', vehicle.category),
      configuration: createConfiguration('VWBasic_VehicleButton_Click', vehicle, lang),
      partner: createPartner(dealer),
      process: createProcess("3"),
      link: {
        url: window.location.href,
        name: e.currentTarget.innerText.trim()
      }
    })
  };

  return (
    vehicle
    ? (
      <BuildYourDealCtaWrapper
        tabIndex={-1}
        href="#"
        className="motocommerce-vehicle-link"
        data-stock-id={!vehicle.in_production ? vehicle.vin : vehicle.stock_number}
        onClick={(e) => onBuildCta(e)}
      >
        <CustomDetailsCTA
          ariaLabel={trans.details.motoinsights.cta}
          emphasis="primary"
          tag="button"
        >
          {trans.details.motoinsights.continue}
        </CustomDetailsCTA>
      </BuildYourDealCtaWrapper>
    )
    : null
  );
};
